import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoaderComponent} from './loader.component';
import {TuiLoaderModule} from '@taiga-ui/core';
import {RiveLoaderComponent} from './rive-loader/rive-loader.component';

@NgModule({
  declarations: [LoaderComponent, RiveLoaderComponent],
  exports: [LoaderComponent],
  imports: [CommonModule, TuiLoaderModule],
})
export class LoaderModule {}
